import React from 'react';
import { useIntl } from '@kamernet/core/Intl';
import { Typography } from '@mui/material';
import { PageLayout } from '@kamernet/core/PageLayout';
import HomeIcon from '@kamernet/icons/Home.svg';
import QuotesIcon from '@kamernet/icons/Quotes.svg';
import CandidatesIcon from '@kamernet/icons/Candidates.svg';
import { CommonStyles } from '@kamernet/styles/CommonStyles';
import styles from './ThreeSimpleSteps.module.css';

export const ThreeSimpleSteps = () => {
  const { T } = useIntl();

  return (
    <PageLayout.SectionContainer className={styles.root}>
      <Typography className={styles.title} variant="h2">
        {T('LBL_HOME_SUPPLY_HOMEPAGE_HOW_IT_WORKS_TITLE_ROOM_NETHERLANDS')}
      </Typography>
      <div className={styles.steps}>
        <div className={styles.step}>
          <HomeIcon fontSize="large" className={styles.stepIcon} />
          <Typography variant="h4" className={CommonStyles.margin_bottom_1}>
            {T('LBL_HOME_SUPPLY_HOW_IT_WORKS_TITLE1')}
          </Typography>
          <Typography variant="body2">
            {T('LBL_HOME_SUPPLY_HOW_IT_WORKS_TEXT1')}
          </Typography>
        </div>
        <div className={styles.step}>
          <QuotesIcon fontSize="large" className={styles.stepIcon} />
          <Typography variant="h4" className={CommonStyles.margin_bottom_1}>
            {T('LBL_HOME_SUPPLY_HOW_IT_WORKS_TITLE2')}
          </Typography>
          <Typography variant="body2">
            {T('LBL_HOME_SUPPLY_HOW_IT_WORKS_TEXT2')}
          </Typography>
        </div>
        <div className={styles.step}>
          <CandidatesIcon fontSize="large" className={styles.stepIcon} />
          <Typography variant="h4" className={CommonStyles.margin_bottom_1}>
            {T('LBL_HOME_SUPPLY_HOW_IT_WORKS_TITLE3')}
          </Typography>
          <Typography variant="body2">
            {T('LBL_HOME_SUPPLY_HOW_IT_WORKS_TEXT3')}
          </Typography>
        </div>
      </div>
    </PageLayout.SectionContainer>
  );
};
